// @flow

import * as React from "react"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"
import {fetchSurvey} from "../../../actions/baby"
import {getSurveyQuestions} from "../../../reducers/baby"
import IntakeDataNav from "../../../components/intake/data-nav"
import SurveyQuestions from "../../../components/intake/survey-questions"
// import {set, cloneDeep} from 'lodash'
import type {State as ReduxState, Baby, Survey, Dispatch} from "../../../types"

type Props = {
  t: any,
  dispatch: Dispatch,
  match: any,
  isSaving: boolean,
  baby: Baby,
  survey: Survey,
}

class IntakeDataSurveyView extends React.Component<Props> {
  componentDidMount() {
    const {
      survey,
      dispatch,
      match: {
        params: {babyToken},
      },
    } = this.props
    if (!survey) {
      dispatch(fetchSurvey(babyToken))
    }
  }

  render() {
    const {survey, baby, isSaving} = this.props
    if (!survey) {
      return null
    }
    return (
      <div className="container pb-5">
        <IntakeDataNav isSaving={isSaving} />
        <div className="row">
          <div className="col-md-8 col-lg-8 col-xl-6">
            <SurveyQuestions
              isSaving={isSaving}
              survey={survey}
              babyToken={baby.token}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => {
  const survey = state.baby.survey
    ? getSurveyQuestions(state.baby.survey, "intake_email")
    : null
  return {
    baby: state.baby.baby,
    isSaving: state.baby.isIntakeSaving,
    survey,
  }
}

export default withTranslation()(connect(mapStateToProps)(IntakeDataSurveyView))
